<template>
  <div>
    <base-dialog
      @save-item="saveItem"
      dialogId="edit-attribute-dialog"
      :open.sync="openDialog"
      :form-ref.sync="attributeFormRef"
      :loading.sync="isLoading"
    >
      <template v-slot:[`dialog.title`]>
        <span>Editer un attribut</span>
      </template>
      <template v-slot:[`dialog.content`]>
        <v-select
          v-model="attributeForm.name"
          label="Nom"
          :items="attributesChoice"
        >
        </v-select>
        <v-text-field
          v-model="attributeForm.value"
          label="Valeur"
          :rules="rules.valueRules"
        >
        </v-text-field>
        <v-textarea v-model="attributeForm.comment" label="Commentaire">
        </v-textarea>
        <p>
          Les commentaires sont utilisés pour savoir par qui et pour quelle
          raison l'attribut a été ajouté
        </p>
      </template>
      <template v-slot:[`dialog.actions.save`]>Modifier</template>
    </base-dialog>
  </div>
</template>
<script>
import { toRefs, watch, computed } from "@vue/composition-api";
import { useAttributes } from "@/composables/attribute";
import BaseDialog from "@/components/General/BaseDialog.vue";

export default {
  components: {
    BaseDialog,
  },
  props: {
    attribute: Object,
    open: Boolean,
  },
  setup(props, { emit }) {
    /* Import des API */
    const { attributeData, updateAttribute, attributes } = useAttributes();

    /* Variables */
    const { name, value, comment } = props.attribute;
    attributeData.attributeForm = { name, value, comment };

    /* Computed */
    const openDialog = computed({
      get: function () {
        return props.open;
      },
      set: function (value) {
        emit("update:open", value);
      },
    });

    /* Watchers */
    watch(
      () => attributes.value,
      function (newValue, oldValue) {
        if (newValue != oldValue && newValue != null) {
          emit("update:attributes", newValue);
        }
      }
    );

    /* Méthodes */
    const saveItem = async function () {
      await updateAttribute(props.attribute);
      openDialog.value = attributeData.editAttributeDialog;
    };

    return {
      updateAttribute,
      ...toRefs(attributeData),
      saveItem,
      openDialog,
    };
  },
};
</script>
